import React from 'react';
import icCarolus from '../../assets/logo_rs.png';
import icMed from '../../assets/medapp.png';
import icMedKecil from '../../assets/IgMedIcon.png';
import logoKwitansi from '../../assets/logokwitansi.png';
import { Typography } from '@material-ui/core';
import QRCode from "react-qr-code";
import Constant from '../../library/Constant';
import { format } from 'date-fns';
import { getAge } from '../../library/Util';

export class ComponentKwitansi extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visibleRegis: true,
      strDate: '',
      strTime: ''
    }
  }

  componentDidMount() {
    console.log(this.props);
    this.setState({
      visibleRegis: this.props.pembayaran === 'umum' ? false : true
    })
    this.tick()
    this.getDate()
  }

  getDate() {
    var date = new Date();
    var tahun = date.getFullYear();
    var bulan = date.getMonth();
    var tanggal = date.getDate();
    var hari = date.getDay();
    switch (hari) {
      case 0: hari = "Minggu"; break;
      case 1: hari = "Senin"; break;
      case 2: hari = "Selasa"; break;
      case 3: hari = "Rabu"; break;
      case 4: hari = "Kamis"; break;
      case 5: hari = "Jum'at"; break;
      case 6: hari = "Sabtu"; break;
    }
    switch (bulan) {
      case 0: bulan = "Jan"; break;
      case 1: bulan = "Feb"; break;
      case 2: bulan = "Mar"; break;
      case 3: bulan = "Apr"; break;
      case 4: bulan = "Mei"; break;
      case 5: bulan = "Jun"; break;
      case 6: bulan = "Jul"; break;
      case 7: bulan = "Agu"; break;
      case 8: bulan = "Sep"; break;
      case 9: bulan = "Okt"; break;
      case 10: bulan = "Nov"; break;
      case 11: bulan = "Des"; break;
    }
    let strDate = tanggal + '-' + bulan + '-' + tahun
    this.setState({ strDate })
  }

  tick() {
    this.setState({
      jam: new Date().getHours(),
      menit: new Date().getMinutes()
    }, () => {
      var ampm = this.state.jam >= 12 ? 'PM' : 'AM';
      this.state.jam = this.state.jam % 12;
      this.state.jam = this.state.jam ? this.state.jam : 12; // the hour '0' should be '12'
      this.state.menit = this.state.menit < 10 ? '0' + this.state.menit : this.state.menit;
      var strTime = this.state.jam + ':' + this.state.menit;
      this.setState({
        strTime
      })
    });
  }

  render() {
    return (
      <div className='print-source page-kwitansi'>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex' }}>
            <img src={localStorage.getItem(Constant.LOGO_CETAKAN)} style={{ width: '5.5em', height: '6.5em', marginRight: '1mm' }} />
            <div style={{ display: 'grid', justifyContent: 'space-between', flex: 1, marginRight: '10mm', marginTop: 4 }}>
              <Typography style={{ fontSize: '4mm', fontFamily: 'Poppins', textAlignLast: 'left', fontWeight: 'bold' }}>{localStorage.getItem(Constant.NAMA_RS)}</Typography>
              <Typography style={{ fontSize: '3.5mm', fontFamily: 'Poppins', textAlignLast: 'left' }}>{localStorage.getItem(Constant.ALAMAT_RS)}</Typography>
              <Typography style={{ fontSize: '3.5mm', fontFamily: 'Poppins', textAlignLast: 'left' }}>{localStorage.getItem(Constant.PHONE_RS)}</Typography>
            </div>
            <img src={icMed} style={{ marginLeft: 10, width: '13em', height: '4em' }} />
          </div>
          <div>
            <Typography style={{ fontSize: '10mm', fontFamily: 'Poppins' }}>KUITANSI</Typography>
          </div>
        </div>
        <div style={{ display: 'flex', marginBottom: '5mm', marginTop: '3mm', justifyContent: 'center', borderBottomWidth: '.4mm', borderBottomStyle: 'solid', borderBottomColor: '#bdc3c7', padding: '2mm 0mm' }} />

        <div style={{ display: 'flex', marginTop: '1mm' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '30%' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fontWeight: '200' }}>Nomor Kuitansi</Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '5%' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fontWeight: '200' }}>:</Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#000000' }}>{this.props.datakuitansi.transaction_no}</Typography>
          </div>
        </div>
        <div style={{ display: 'flex', marginTop: '1mm' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '30%' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fonWeight: '200' }}>Tanggal Kwitansi </Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '5%' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fontWeight: '200' }}>:</Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#000000' }}>{format(new Date(this.props.datakuitansi.updated_at), 'dd MMM yyyy - HH:mm')}</Typography>
          </div>
        </div>
        <div style={{ display: 'flex', marginTop: '1mm' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '30%' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fonWeight: '200' }}>Sudah Diterima Dari </Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '5%' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fontWeight: '200' }}>:</Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#000000' }}>{this.props.datakuitansi.patient}</Typography>
          </div>
        </div>
        <div style={{ display: 'flex', marginTop: '1mm' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '30%' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fonWeight: '200' }}>Uang Sejumlah </Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '5%' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fontWeight: '200' }}>:</Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#000000' }}>{this.props.datakuitansi.total_price}</Typography>
          </div>
        </div>
        <div style={{ display: 'flex', marginTop: '1mm' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '30%' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fonWeight: '200' }}>Terbilang </Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '5%' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fontWeight: '200' }}>:</Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#000000' }}>{this.props.datakuitansi.total_price_desc}</Typography>
          </div>
        </div>
        <div style={{ display: 'flex', marginTop: '1mm' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '42%' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fonWeight: '200' }}>Keterangan </Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '7%' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fontWeight: '200' }}>:</Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '91%' }}>
            <Typography style={{ fontSize: '5mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#000000' }}>({this.props.datakuitansi.medical_record_no === "" ? "-" : this.props.datakuitansi.medical_record_no}) {this.props.datakuitansi.patient} - {this.props.datakuitansi.registration_no} - {this.props.datakuitansi.polyclinic}</Typography>
          </div>
        </div>
        {/* <div style={{ display: 'flex', marginTop: '1mm', marginBottom: '2mm', justifyContent: 'center', borderBottomWidth: '.4mm', borderBottomStyle: 'solid', borderBottomColor: '#bdc3c7', padding: '2mm 0mm' }} /> */}
        <div style={{ display: 'flex', marginTop: '25mm', justifyContent: 'flex-end' }}>
          <div style={{ marginTop: '2mm', width: '40%' }}>
            <Typography style={{ fontSize: '4mm', fontFamily: 'Poppins', fonWeight: 'bold', color: 'black', textAlign: 'center' }}>Jakarta, {format(new Date(), 'dd MMM yyyy')}</Typography>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              <div style={{ width: '75%', borderBottomWidth: '.4mm', borderBottomStyle: 'solid', borderBottomColor: '#bdc3c7', height: '10em' }} />
            </div>
            <Typography style={{ marginTop: '2mm', fontSize: '4mm', fontFamily: 'Poppins', fonWeight: 'bold', color: 'black', textAlign: 'center' }}>“Casier”</Typography>
          </div>
        </div>
        {/* <div style={{ display: 'flex', justifyContent: 'center', marginTop: '5mm', borderBottomWidth: '.2mm', borderBottomStyle: 'solid', borderBottomColor: '#bdc3c7', padding: '2mm 0mm' }}>
          <div>
            <Typography style={{ fontSize: '4mm', fontFamily: 'Poppins', textAlignLast: 'center' }}>Antrian</Typography>
            <Typography style={{ fontSize: '4mm', fontFamily: 'Poppins' }}>Farmasi Dalam</Typography>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm' }}>
          <Typography style={{ fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: 'black' }}>Kode Reservasi</Typography>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm' }}>
          <Typography style={{ fontSize: '4mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#00000', fontWeight: '500' }}>{this.props.kodePesanan}</Typography>
        </div>
        <div style={{ display: 'flex', marginTop: '.5mm' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '30%' }}>
            <Typography style={{ fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: 'black' }}>Nama Pasien</Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm' }}>
            <Typography style={{ fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#000000' }}>{this.props.namaPasien}</Typography>
          </div>
        </div>
        <div style={{ display: 'flex', marginTop: '.5mm' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '30%' }}>
            <Typography style={{ fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: 'black' }}>Lokasi</Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm' }}>
            <Typography style={{ fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#000000' }}>{this.props.lokasi}</Typography>
          </div>
        </div>
        <div style={{ display: 'flex', marginTop: '.5mm' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm', width: '30%' }}>
            <Typography style={{ fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: 'black' }}>Status Produksi</Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '2mm' }}>
            <Typography style={{ fontSize: '3mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#000000' }}>{this.props.status === 1 ? "Belum Diproduksi" : this.props.status === 2 ? "Produksi" : "Selesai"}</Typography>
          </div>
        </div>
        <div style={{ display: 'contents', justifyContent: 'center', width: '30%', marginTop: '12mm', }}>
          <div style={{ marginTop: '12mm', display: 'flex', justifyContent: 'center' }}>
            <Typography style={{ fontSize: '3.5mm', fontFamily: 'Poppins', fonWeight: 'bold', color: 'black', textAlign: 'center' }}>No. Antrian</Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Typography style={{ fontSize: '15mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#000000', fontWeight: 'bold', textAlign: 'center' }}>{this.props.noAntrian}</Typography>
          </div> 
        </div> 
        <div style={{ display: 'flex', marginTop: '9mm', alignItems: 'center', alignSelf: 'center' }}>
          <img src={icMedKecil} style={{ width: '1em', height: '1em', marginRight: '2mm' }} />
          <Typography style={{ fontSize: '2mm', fontFamily: 'Poppins', fonWeight: 'bold', color: '#838994' }}>@2020 Powered By : Eksad Technology</Typography>
        </div> */}
      </div>
    );
  }
}